<template>
  <div class="LorRbg">
    <div class="w1000 clearfix">
      <div class="LorRright style2">
        <h2 class="pubtitle">忘记密码</h2>
        <el-tabs v-model="activeName" class="tabcon1">
          <el-tab-pane name="first">
            <span slot="label">
              <span class="span-box">
                <span class="num">1</span>
                <span class="title">确认账户</span>
              </span>
            </span>
            <el-form ref="forgetForm1" :model="forgetForm1" :rules="forgetRules1">
              <el-form-item prop="phone">
                <i class="icon icon1"></i>
                <el-input v-model="forgetForm1.phone" placeholder="手机号/账号"></el-input>
              </el-form-item>
              <el-form-item class="verification" prop="verCode">
                <i class="icon icon3"></i>
                <el-input v-model="forgetForm1.verCode" placeholder="验证码"></el-input>
                <p class="code" v-show="verShow" @click="getauthcode">获取验证码</p>
                <p class="code gray" v-show="!verShow">重新发送<i>{{timer}}</i>s</p>
              </el-form-item>
              <a class="lorbtn" :class="{ active: twoforgetconfirm}" @click="nextpassword">下一步</a>
            </el-form>
          </el-tab-pane>
          <el-tab-pane :disabled="twoforgetFlag" name="two">
            <span slot="label">
              <span class="span-box">
                <span class="num line">2</span>
                <span class="title">重置密码</span>
              </span>
            </span>
             <el-form ref="forgetForm2" :model="forgetForm2" :rules="forgetRules2">
              <el-form-item prop="password">
                <i class="icon icon2"></i>
                <el-input v-model="forgetForm2.password" placeholder="设置新密码" type="password"></el-input>
              </el-form-item>
              <el-form-item prop="conPassword">
                <i class="icon icon2"></i>
                <el-input v-model="forgetForm2.conPassword" placeholder="确认新密码" type="password"></el-input>
              </el-form-item>
               <div class="describe">密码要求6-16位，至少包含数字、字母、符号两种元素</div>
              <a class="lorbtn" :class="{ active: threeforgetconfirm}" @click="confirpassword">下一步</a>
            </el-form>
          </el-tab-pane>
          <el-tab-pane :disabled="threeforgetFlag" name="three">
            <span slot="label">
              <span class="span-box">
                <span class="num">3</span>
                <span class="title">完成</span>
              </span>
            </span>
            <div class="complete pubcon">
              <i class="el-icon-circle-check"></i>
              <p>恭喜您已重置密码，快来 <span>登录</span> 吧~</p>
              <a class="lorbtn" @click="completeEv">完成</a>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="LorRleft">
        <div class="codebox" v-if="codeFlag">
          <div class="imgbox">
            <img :src="downloadImg" alt="">
          </div>
          <p>{{ downloadtext }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getVERCode, setForget } from '@/api/user/index'
export default {
  name: 'forget',
  meta: {
    showHeader: true
  },
  data () {
    const checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(this.$message.error('手机号不能为空'))
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号'))
        }
      }
    }
    const validatePass1 = (rule, value, callback) => {
      const passwordReg = /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{6,16}$/
      if (!value) {
        return callback(new Error('密码不能为空'))
      }
      setTimeout(() => {
        if (passwordReg.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的密码格式'))
        }
      }, 100)
    }
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.forgetForm2.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      /* tab选项卡默认值 */
      activeName: 'first',
      /* 二维码控制 */
      codeFlag: true,
      verShow: true,
      forgetForm1: {
        phone: '',
        verCode: ''
      },
      forgetForm2: {
        password: '',
        conPassword: '',
        departmentCode: this.$cookie.get('museumCode')
      },
      forgetRules1: {
        phone: [{required: true, validator: checkPhone, trigger: 'blur'}],
        verCode: [{required: true, message: '验证码不能为空', trigger: 'blur'}]
      },
      forgetRules2: {
        password: [{required: true, validator: validatePass1, trigger: 'blur'}],
        conPassword: [{required: true, validator: validatePass2, trigger: 'blur'}]
      },
      twoforgetFlag: true,
      threeforgetFlag: true,
      timer: 60,
      timers: null,
      twoforgetconfirm: false,
      threeforgetconfirm: false,
      List: [],
      unitName: '',
      downloadImg: require('@/assets/common/images/ewm.png'),
      downloadtext: '下载学习通'
    }
  },
  watch: {
    'forgetForm.verCode' (val) {
      if (val) {
        this.twoforgetconfirm = true
      }
    },
    'forgetForm.conPassword' (val) {
      if (val) {
        this.threeforgetconfirm = true
      }
    },
    adSlot (val) {
      if (val) {
        this.List = val
        this.getData()
      }
    }
  },
  computed: {
    adSlot () {
      return this.$store.state.adSlot.list
    }
  },
  mounted () {
    if (this.$store.state.adSlot.list.length !== 0) {
      this.List = this.$store.state.adSlot.list
      this.getData()
    }
  },
  methods: {
    getData () {
      this.List.forEach(item => {
        if (item.slotCode === 'downloadconfig') {
          this.downloadtext = item.slotName
          if (item.imgPath !== undefined && item.imgPath !== '') {
            this.downloadImg = item.imgPath
          }
        }
      })
    },
    /* 获取验证码 */
    getauthcode () {
      if (this.forgetForm1.phone !== '') {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        if (!reg.test(this.forgetForm1.phone)) {
          this.$message({message: '请输入正确的手机号', type: 'warning'})
          return
        }
        this.verShow = false
        let authtimer = setInterval(() => {
          this.timer--
          if (this.timer <= 0) {
            this.verShow = true
            this.timer = 60
            clearInterval(authtimer)
          }
        }, 1000)
        const obj = {'status': 2, 'unitName': ''}
        getVERCode(this.forgetForm1.phone, obj).then((res) => {
          if (res.data.status === 200) {
            this.$message({message: res.data.data, type: 'success'})
          } else {
            this.$message.error(res.data.message)
          }
        })
      } else {
        this.$message({message: '请填写手机号', type: 'warning'})
      }
    },
    /* 获取验证码下一步 */
    nextpassword () {
      this.$refs['forgetForm1'].validate((valid) => {
        if (valid) {
          this.activeName = 'two'
        }
      })
    },
    /* 重置密码下一步 */
    confirpassword () {
      this.$refs['forgetForm2'].validate((valid) => {
        if (valid) {
          const forgetForm = Object.assign(this.forgetForm1, this.forgetForm2)
          setForget(JSON.stringify(forgetForm)).then((res) => {
            if (res.data.status === 200) {
              this.$message({message: res.data.data, type: 'success'})
              this.activeName = 'three'
            } else {
              this.$message.error(res.data.message)
            }
          })
        }
      })
    },
    /* 完成跳转 */
    completeEv () {
      this.$router.push({path: '/login', query: { redirect: this.$route.query.redirect }})
    }
  },
  beforeDestroy () {
    clearInterval(this.timers)
    this.timers = null
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/common/scss/_user.scss";

</style>



// WEBPACK FOOTER //
// src/view/user/forget.vue